import { render, staticRenderFns } from "./export-report-historical-data-modal.vue?vue&type=template&id=052f6dea"
import script from "./export-report-historical-data-modal.vue?vue&type=script&lang=js"
export * from "./export-report-historical-data-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports